import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Skill Practice: Double or Triple Unders`}</p>
    <p>{`then,`}</p>
    <p>{`Tabata back squats, 95/65lb.\\
Rest 1 minute\\
Tabata L-sit\\
Rest 1 minute\\
Tabata ring rows\\
Rest 1 minute\\
Tabata handstand hold\\
Rest 1 minute\\
Tabata row`}</p>
    <p>{`The Tabata interval is 20 seconds of work followed by 10 seconds of rest
for eight intervals. For L-sit and handstand hold, count the number of
seconds maintained in the hold.`}</p>
    <p>{`Post total reps/seconds/calories for each exercise.`}</p>
    <p><strong parentName="p"><em parentName="strong">{`*`}{`Reminder: Our new Ville schedule takes effect this week!  Check it
out on the Schedule page.`}</em></strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      